/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AllShipmentsCalendar,
  AllShipmentsHeaderStats,
  AllShipmentsMapPoint,
  AllShipmentsPage,
  AllShipmentsSearchRequest,
  AllShipmentsStatistics,
  CarrierShipmentReportRequest,
  CustomerShipmentReportRequest,
  DetailedShipmentReport,
  HubbleMapCompany,
  HubbleShipmentFiltersQuery,
} from "../models/index";
import {
  AllShipmentsCalendarFromJSON,
  AllShipmentsCalendarToJSON,
  AllShipmentsHeaderStatsFromJSON,
  AllShipmentsHeaderStatsToJSON,
  AllShipmentsMapPointFromJSON,
  AllShipmentsMapPointToJSON,
  AllShipmentsPageFromJSON,
  AllShipmentsPageToJSON,
  AllShipmentsSearchRequestFromJSON,
  AllShipmentsSearchRequestToJSON,
  AllShipmentsStatisticsFromJSON,
  AllShipmentsStatisticsToJSON,
  CarrierShipmentReportRequestFromJSON,
  CarrierShipmentReportRequestToJSON,
  CustomerShipmentReportRequestFromJSON,
  CustomerShipmentReportRequestToJSON,
  DetailedShipmentReportFromJSON,
  DetailedShipmentReportToJSON,
  HubbleMapCompanyFromJSON,
  HubbleMapCompanyToJSON,
  HubbleShipmentFiltersQueryFromJSON,
  HubbleShipmentFiltersQueryToJSON,
} from "../models/index";

export interface GenerateCarrierShipmentReportRequest {
  carrierShipmentReportRequest: CarrierShipmentReportRequest;
}

export interface GenerateCustomerShipmentReportRequest {
  customerShipmentReportRequest: CustomerShipmentReportRequest;
}

export interface GenerateShipmentFiltersRequest {
  hubbleShipmentFiltersQuery: HubbleShipmentFiltersQuery;
}

export interface GetMatchingShipmentIdsRequest {
  hubbleShipmentFiltersQuery: HubbleShipmentFiltersQuery;
}

export interface GetShipmentsCalendarRequest {
  hubbleShipmentFiltersQuery: HubbleShipmentFiltersQuery;
}

export interface GetShipmentsHeaderStatsRequest {
  hubbleShipmentFiltersQuery: HubbleShipmentFiltersQuery;
}

export interface GetShipmentsMapPointsRequest {
  hubbleShipmentFiltersQuery: HubbleShipmentFiltersQuery;
}

export interface GetShipmentsStatisticsRequest {
  hubbleShipmentFiltersQuery: HubbleShipmentFiltersQuery;
}

export interface SearchAllShipmentsRequest {
  allShipmentsSearchRequest: AllShipmentsSearchRequest;
}

/**
 *
 */
export class MapApi extends runtime.BaseAPI {
  /**
   * The Carrier Shipment Report spreadsheet, or 204 when no shipment makes it in
   */
  async generateCarrierShipmentReportRaw(
    requestParameters: GenerateCarrierShipmentReportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters["carrierShipmentReportRequest"] == null) {
      throw new runtime.RequiredError(
        "carrierShipmentReportRequest",
        'Required parameter "carrierShipmentReportRequest" was null or undefined when calling generateCarrierShipmentReport().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/carrier-shipment-report`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierShipmentReportRequestToJSON(
          requestParameters["carrierShipmentReportRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * The Carrier Shipment Report spreadsheet, or 204 when no shipment makes it in
   */
  async generateCarrierShipmentReport(
    requestParameters: GenerateCarrierShipmentReportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Blob | null | undefined> {
    const response = await this.generateCarrierShipmentReportRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * The Customer Shipment Report spreadsheet, or 204 when no shipment matches
   */
  async generateCustomerShipmentReportRaw(
    requestParameters: GenerateCustomerShipmentReportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters["customerShipmentReportRequest"] == null) {
      throw new runtime.RequiredError(
        "customerShipmentReportRequest",
        'Required parameter "customerShipmentReportRequest" was null or undefined when calling generateCustomerShipmentReport().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/customer-shipment-report`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CustomerShipmentReportRequestToJSON(
          requestParameters["customerShipmentReportRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * The Customer Shipment Report spreadsheet, or 204 when no shipment matches
   */
  async generateCustomerShipmentReport(
    requestParameters: GenerateCustomerShipmentReportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Blob | null | undefined> {
    const response = await this.generateCustomerShipmentReportRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   */
  async generateShipmentFiltersRaw(
    requestParameters: GenerateShipmentFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<DetailedShipmentReport>>> {
    if (requestParameters["hubbleShipmentFiltersQuery"] == null) {
      throw new runtime.RequiredError(
        "hubbleShipmentFiltersQuery",
        'Required parameter "hubbleShipmentFiltersQuery" was null or undefined when calling generateShipmentFilters().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/generate-shipment-filters`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HubbleShipmentFiltersQueryToJSON(
          requestParameters["hubbleShipmentFiltersQuery"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(DetailedShipmentReportFromJSON),
    );
  }

  /**
   */
  async generateShipmentFilters(
    requestParameters: GenerateShipmentFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<DetailedShipmentReport>> {
    const response = await this.generateShipmentFiltersRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCompaniesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<HubbleMapCompany>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/get-companies`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(HubbleMapCompanyFromJSON),
    );
  }

  /**
   */
  async getCompanies(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<HubbleMapCompany>> {
    const response = await this.getCompaniesRaw(initOverrides);
    return await response.value();
  }

  /**
   * The id of every shipment matching the filters, for bulk actions
   */
  async getMatchingShipmentIdsRaw(
    requestParameters: GetMatchingShipmentIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<string>>> {
    if (requestParameters["hubbleShipmentFiltersQuery"] == null) {
      throw new runtime.RequiredError(
        "hubbleShipmentFiltersQuery",
        'Required parameter "hubbleShipmentFiltersQuery" was null or undefined when calling getMatchingShipmentIds().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/shipment-ids`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HubbleShipmentFiltersQueryToJSON(
          requestParameters["hubbleShipmentFiltersQuery"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * The id of every shipment matching the filters, for bulk actions
   */
  async getMatchingShipmentIds(
    requestParameters: GetMatchingShipmentIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<string>> {
    const response = await this.getMatchingShipmentIdsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Activity per day for the Calendar view of the matching shipments
   */
  async getShipmentsCalendarRaw(
    requestParameters: GetShipmentsCalendarRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AllShipmentsCalendar>> {
    if (requestParameters["hubbleShipmentFiltersQuery"] == null) {
      throw new runtime.RequiredError(
        "hubbleShipmentFiltersQuery",
        'Required parameter "hubbleShipmentFiltersQuery" was null or undefined when calling getShipmentsCalendar().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/calendar`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HubbleShipmentFiltersQueryToJSON(
          requestParameters["hubbleShipmentFiltersQuery"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AllShipmentsCalendarFromJSON(jsonValue),
    );
  }

  /**
   * Activity per day for the Calendar view of the matching shipments
   */
  async getShipmentsCalendar(
    requestParameters: GetShipmentsCalendarRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AllShipmentsCalendar> {
    const response = await this.getShipmentsCalendarRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The header totals for the shipments matching the filters
   */
  async getShipmentsHeaderStatsRaw(
    requestParameters: GetShipmentsHeaderStatsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AllShipmentsHeaderStats>> {
    if (requestParameters["hubbleShipmentFiltersQuery"] == null) {
      throw new runtime.RequiredError(
        "hubbleShipmentFiltersQuery",
        'Required parameter "hubbleShipmentFiltersQuery" was null or undefined when calling getShipmentsHeaderStats().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/header-stats`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HubbleShipmentFiltersQueryToJSON(
          requestParameters["hubbleShipmentFiltersQuery"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AllShipmentsHeaderStatsFromJSON(jsonValue),
    );
  }

  /**
   * The header totals for the shipments matching the filters
   */
  async getShipmentsHeaderStats(
    requestParameters: GetShipmentsHeaderStatsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AllShipmentsHeaderStats> {
    const response = await this.getShipmentsHeaderStatsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Pickup and delivery coordinates for the Map view of the matching shipments
   */
  async getShipmentsMapPointsRaw(
    requestParameters: GetShipmentsMapPointsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<AllShipmentsMapPoint>>> {
    if (requestParameters["hubbleShipmentFiltersQuery"] == null) {
      throw new runtime.RequiredError(
        "hubbleShipmentFiltersQuery",
        'Required parameter "hubbleShipmentFiltersQuery" was null or undefined when calling getShipmentsMapPoints().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/map-points`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HubbleShipmentFiltersQueryToJSON(
          requestParameters["hubbleShipmentFiltersQuery"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AllShipmentsMapPointFromJSON),
    );
  }

  /**
   * Pickup and delivery coordinates for the Map view of the matching shipments
   */
  async getShipmentsMapPoints(
    requestParameters: GetShipmentsMapPointsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<AllShipmentsMapPoint>> {
    const response = await this.getShipmentsMapPointsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Every number the Statistics view shows for the matching shipments
   */
  async getShipmentsStatisticsRaw(
    requestParameters: GetShipmentsStatisticsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AllShipmentsStatistics>> {
    if (requestParameters["hubbleShipmentFiltersQuery"] == null) {
      throw new runtime.RequiredError(
        "hubbleShipmentFiltersQuery",
        'Required parameter "hubbleShipmentFiltersQuery" was null or undefined when calling getShipmentsStatistics().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/statistics`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HubbleShipmentFiltersQueryToJSON(
          requestParameters["hubbleShipmentFiltersQuery"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AllShipmentsStatisticsFromJSON(jsonValue),
    );
  }

  /**
   * Every number the Statistics view shows for the matching shipments
   */
  async getShipmentsStatistics(
    requestParameters: GetShipmentsStatisticsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AllShipmentsStatistics> {
    const response = await this.getShipmentsStatisticsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * One page of the shipments matching the filters, and how many match
   */
  async searchAllShipmentsRaw(
    requestParameters: SearchAllShipmentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AllShipmentsPage>> {
    if (requestParameters["allShipmentsSearchRequest"] == null) {
      throw new runtime.RequiredError(
        "allShipmentsSearchRequest",
        'Required parameter "allShipmentsSearchRequest" was null or undefined when calling searchAllShipments().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/shipment-filters/search`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AllShipmentsSearchRequestToJSON(
          requestParameters["allShipmentsSearchRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AllShipmentsPageFromJSON(jsonValue),
    );
  }

  /**
   * One page of the shipments matching the filters, and how many match
   */
  async searchAllShipments(
    requestParameters: SearchAllShipmentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AllShipmentsPage> {
    const response = await this.searchAllShipmentsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
